/* eslint-disable @nx/enforce-module-boundaries */
import { HStack, Text } from '@chakra-ui/react';
import NotesIcon from '@gamma/ui/icons/NotesSharpIcon';
import { AccordionPanel } from '@gamma/ui/layout';
import { FC, useMemo, useState } from 'react';
import { Detection } from '../../../../../../shared/generated/graphql';
import { i18n } from '../../../../../../shared/localization';
import Anomaly from './Layouts/Anomaly';
import General from './Layouts/General';
import Suricata from './Layouts/Suricata';
import Yara from './Layouts/Yara';
import { DetectionSummaryProps } from './types';

const layoutMap = {
  anomaly: Anomaly,
  general: General,
  yara: Yara,
  suricata: Suricata,
};

export const DetectionSummary: FC<DetectionSummaryProps> = ({
  detectionDetailsProps,
}) => {
  const detectionInfo = useMemo(
    () => detectionDetailsProps?.detectionData?.getDetections?.detections[0],
    [detectionDetailsProps],
  );

  const metadata = useMemo(
    () => detectionDetailsProps?.metadataData?.getAlertMetadata?.metadata[0],
    [detectionDetailsProps],
  );

  const [isExpanded, setIsExpanded] = useState(false);

  const alertType = useMemo(() => {
    if (metadata?.logsource?.category === 'suricata_corelight')
      return 'suricata';
    if (metadata?.logsource?.category === 'yara_corelight') return 'yara';
    if (detectionInfo?.alert_info?.alert_type === 'anomaly') return 'anomaly';
    return 'notice';
  }, [detectionInfo, metadata]);

  if (!detectionInfo || !metadata) {
    return null;
  }

  const { detectionSummary } = i18n.pages.detections;

  const Layout =
    layoutMap[alertType as keyof typeof layoutMap] ?? layoutMap.general;

  return (
    <AccordionPanel
      w="100%"
      data-testid="detection-summary"
      title={
        <HStack>
          <NotesIcon />
          <Text>{detectionSummary.title}</Text>
        </HStack>
      }
      reduceMotion={true}
      storageKey="detection-summary"
    >
      <Layout
        detectionInfo={detectionInfo as Detection}
        metadata={metadata}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        detailsProps={detectionDetailsProps}
      />
    </AccordionPanel>
  );
};
